import Explanations from './Explanations'

export default Explanations
